import { ModelDef } from '../index'

const model: ModelDef = {
  tableName: 'userGroups',
  tableLabel: 'グループ管理',
  tableComment: '',
  timestamps: true,
  defaultSort: { key: 'name', order: 'asc' },
  useAlgolia: false,
  columns: {
    name: {
      label: 'グループ名称',
      type: 'STRING',
      validate: { notEmpty: true },
      searchable: true,
      unique: true,
    },
    description: {
      label: '説明',
      type: 'TEXT',
    },
    members: {
      label: 'メンバー',
      type: 'MULTISELECT',
      inputAttrs: { wrapperClass: 'col-12' },
      selections: async ($store, record, currentValue, initialValue) => {
        // FIXME: remove window
        // reference all users
        const selections = (await window.$nuxt.$models.users.findAll()).map((u) => ({
          id: u.id,
          name: u.name,
        }))
        // inject name in current value
        if (currentValue) {
          currentValue.forEach((v) => {
            v.name = selections.find(({ id }) => id === v.id)?.name || `unknown user: ${v.id}`
          })
        }
        return selections
      },
      strictSelections: true,
      trackBy: 'id',
      customLabel: ({ name }) => name,
    },
  },
  showOnMainmenu: false,
  showOnSettingMenu: true,
  shouldCreateHistoryData: ({ before, after }) => false,
  beforeSave: (data) => {
    // save only user.id
    data.members = data.members.map(({ id }) => ({ id }))
    return data
  },
}

export default model
